import * as React from "react";
import { cn } from "@/lib/utils";
import ChevronRight from "@/app/assets/icons/chevron-right";

interface InputProps extends React.ComponentProps<"input"> {
    icon?: React.ReactElement;
    showRightIcon?: boolean;
    iconStyles?: string;
    inputStyles?: string;
    showIcon?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    (
        {
            className,
            type,
            showIcon = true,
            icon = <ChevronRight />,
            iconStyles,
            inputStyles,
            showRightIcon,
            ...props
        },
        ref,
    ) => {
        return (
            <div
                className={cn(
                    "relative flex w-full items-center border-b border-input px-s6 py-2 [&_svg]:pointer-events-none [&_svg]:size-s9 [&_svg]:shrink-0",
                    className,
                )}
            >
                {showIcon && icon && (
                    <span className={cn(`mr-s6 max-w-fit items-center`, iconStyles)}>{icon}</span>
                )}

                <input
                    type={type}
                    className={cn(
                        // Base styles
                        "h-9 w-full flex-1 bg-transparent p-0 font-regular focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50",

                        // Default text size
                        "text-sm md:text-lg",

                        // Placeholder styles
                        "placeholder:text-neutral-300",

                        // User-defined inputStyles (overrides defaults)
                        inputStyles,
                    )}
                    ref={ref}
                    {...props}
                />

                {showRightIcon && icon && (
                    <span className={cn(`max-w-fit items-center`, iconStyles)}>{icon}</span>
                )}
            </div>
        );
    },
);

Input.displayName = "Input";

export { Input };
